// Admin-only: transit timetables expiring soon and community data surveyed
// more than 5 years ago (gateway /admin/rail/expiring).
import { apiClient } from './api';

export interface RailExpiring {
  operator_id: string; name: string; country: string; valid_until: string; days_left: number;
  reason?: 'expiring' | 'old_survey'; survey_date?: string | null;
}

export const fetchRailExpiring = () =>
  apiClient.get('/admin/rail/expiring').then(r => (r.data.expiring ?? r.data.data?.expiring ?? []) as RailExpiring[]);

/** Registers the transit API as gateway products maps/transit and maps/rail (gateway uses its own secrets). */
export const registerTransit = () => apiClient.post('/admin/transit/register');
